import { useCallback, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TopNavbar from "./TopNavbar";
import { sidebarStyles } from "./../../assets/styles/sidebarStyles";
import MenuDropdownButton from "./menu/MenuDropdownButton";
import MenuButton from "./menu/MenuButton";
import {
  menu,
  menuAcademy,
  menuHome,
  menuIB,
  menuNotifications,
  menuSchedules,
  menuSignals,
  menuUsers,
} from "./menu/menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { Box, ListItemIcon, Typography, useMediaQuery } from "@mui/material";
import Colors from "../../assets/styles/Colors";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import { ExpandLess } from "@mui/icons-material";
import {
  MdCalendarMonth,
  MdCastForEducation,
  MdHome,
  MdPeople,
  MdSignalCellular1Bar,
  MdAccountBalance,
} from "react-icons/md";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { getAdminStatus } from "../store/actions/auth";
import logoWhite from "../../assets/img/logos/logoWhite.png";
const drawerWidth = 280;

const openedMixin = (theme) => ({
  width: drawerWidth,
  boxSizing: "border-box",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),

  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",

  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  backgroundColor: "transparent",
  border: "none",
  borderRadius: "10px !important",
  marginBottom: "6px",
  marginLeft: "8px",
  marginRight: "8px",
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ExpandLess sx={{ fontSize: "1rem", color: Colors.white }} />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "transparent",
  borderRadius: "8px",
  minHeight: "44px",
  margin: "2px 8px",
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  transition: "all 0.2s ease",
  borderBottom: `1px solid ${Colors.borderSecondary}`,
  "&:hover": {
    backgroundColor: Colors.bgElevated,
  },
  "&.Mui-expanded": {
    backgroundColor: Colors.bgElevated,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  "& .MuiAccordionSummary-content": {
    margin: 0,
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1),
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: Colors.white,
    transition: "all 0.2s ease",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    color: Colors.primary,
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(0.5),
  paddingTop: 0,
  backgroundColor: Colors.bgTertiary,
  borderBottomLeftRadius: "10px",
  borderBottomRightRadius: "10px",
  border: `1px solid ${Colors.borderSecondary}`,
  borderTop: "none",
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",

  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function SidebarDrawer({
  handleDrawerToggle,
  sidebarOpen,
  setOpen,
  expired,
}) {
  const theme = useTheme();
  const {
    isSuperAdmin,
    isAlmighty,
    user,
    isModerator: moderator,
  } = useSelector((state) => state.auth);
  const [isSuper, setisSuper] = useState(false);
  const [isModerator, setIsModerator] = useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const getStatus = useCallback(async () => {
    try {
      const status = await getAdminStatus(user?.email);
      return status.adminClaim;
    } catch (error) {
      console.error(error);
      throw error; // Re-throw the error to be caught by the caller
    }
  }, [user]);

  useEffect(() => {
    const fetchAdminStatus = async () => {
      try {
        const adminStatus = await getStatus();
        // console.log(adminStatus);
        if (adminStatus === "superadmin" || adminStatus === "almighty") {
          setisSuper(true);
        } else if (moderator) {
          setIsModerator(true);
        }
      } catch (error) {
        // Handle error if needed
      }
    };

    fetchAdminStatus();
  }, [user, getStatus]);
  // useEffect(() => {
  //   if (isSuperAdmin || isAlmighty) {
  //     setisSuper(true);
  //   }
  // }, [isSuperAdmin, isAlmighty]);

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [openD, setOpenD] = useState({ 3: true });

  function handleClick(id) {
    setOpenD((prevState) => ({ ...prevState, [id]: !prevState[id] }));
  }

  const renderSection = (label, icon, items) => (
    <Box sx={{ px: sidebarOpen ? 1.5 : 0.5, py: 1 }} key={label}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: sidebarOpen ? "flex-start" : "center",
          gap: 1.25,
          px: sidebarOpen ? 1.5 : 0,
          py: 1,
        }}
      >
        <ListItemIcon
          sx={{
            color: Colors.primaryLight,
            minWidth: 0,
            justifyContent: "center",
            fontSize: 20,
          }}
        >
          {icon}
        </ListItemIcon>
        {sidebarOpen && (
          <Typography
            sx={{
              color: Colors.textSecondary,
              fontSize: 11,
              fontWeight: 800,
              letterSpacing: 1.4,
              lineHeight: 1.2,
              textTransform: "uppercase",
            }}
          >
            {label}
          </Typography>
        )}
      </Box>
      <List disablePadding dense>
        {items.map((item) => (
          <Box key={item.title}>
            {item.submenu != null ? (
              <MenuDropdownButton
                open={sidebarOpen}
                openD={openD}
                handleClick={handleClick}
                submenu={item.submenu}
                item={item}
                expired={expired}
              />
            ) : (
              <MenuButton open={sidebarOpen} item={item} expired={expired} />
            )}
          </Box>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <TopNavbar
        drawerWidth={drawerWidth}
        handleDrawerOpen={handleDrawerOpen}
        setOpen={setOpen}
        open={sidebarOpen}
      />

      <Drawer
        variant={
          !isMobile
            ? sidebarOpen
              ? "permanent"
              : "permanent"
            : sidebarOpen
            ? "permanent"
            : "temporary"
        }
        open={sidebarOpen}
        sx={sidebarStyles.drawerStyles}
      >
        <DrawerHeader
          sx={{
            minHeight: "72px !important",
            justifyContent: sidebarOpen ? "space-between" : "center",
            px: sidebarOpen ? 2 : 1,
          }}
        >
          <Box
            className="mr-auto ml-auto"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.25,
              minWidth: 0,
            }}
          >
            <img
              style={{ width: "34px", height: "34px", objectFit: "contain" }}
              src={logoWhite}
              alt="NuCore"
            />
            {sidebarOpen && (
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  sx={{
                    color: Colors.textPrimary,
                    fontSize: 13,
                    fontWeight: 900,
                    letterSpacing: 1.2,
                    lineHeight: 1,
                  }}
                >
                  NuCore Admin
                </Typography>
                <Typography
                  sx={{
                    color: Colors.textSecondary,
                    fontSize: 10,
                    fontWeight: 600,
                    letterSpacing: 0.6,
                    mt: 0.4,
                  }}
                >
                  CRM de Contenido
                </Typography>
              </Box>
            )}
          </Box>

          <IconButton onClick={handleDrawerClose} sx={{ ml: sidebarOpen ? 1 : 0 }}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon sx={{ color: "white" }} />
            ) : (
              <ChevronLeftIcon sx={{ color: "white" }} />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider sx={{ borderColor: "rgba(255,255,255,0.08)" }} />
        <Box
          sx={{
            overflowY: "auto",
            overflowX: "hidden",
            py: 1.5,
            height: "calc(100vh - 73px)",
          }}
        >
          {!isModerator &&
            renderSection("Inicio", <MdHome size={20} />, [...menu, ...menuHome])}
          {!isModerator &&
            renderSection("Academia", <MdCastForEducation size={20} />, menuAcademy)}
          {(isSuper || isModerator) &&
            renderSection("Notificaciones", <MdSignalCellular1Bar size={20} />, menuNotifications)}
          {!isModerator &&
            renderSection("Agenda", <MdCalendarMonth size={20} />, menuSchedules)}
          {(isSuper || isModerator) &&
            renderSection("Trading", <MdSignalCellular1Bar size={20} />, menuSignals)}
          {(isSuper || !isModerator) &&
            renderSection("Usuarios", <MdPeople size={20} />, menuUsers)}
          {isSuper &&
            renderSection("IB / Pagos", <MdAccountBalance size={20} />, menuIB)}
        </Box>
        {/* <Accordion disabled>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Box
              className="mr-auto ml-auto"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",

                mb: 1,
              }}
            >
              <Typography
                variant="h5"
                sx={{ color: Colors.greyLight, fontSize: 18 }}
              >
                Notificaciones
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails
            sx={{ padding: "4px 8px", backgroundColor: "transparent" }}
          >
            <List>
              {menuNotifications.map((item) => {
                return (
                  <div key={item.title}>
                    {item.submenu != null ? (
                      <MenuDropdownButton
                        open={sidebarOpen}
                        openD={openD}
                        handleClick={handleClick}
                        submenu={item.submenu}
                        item={item}
                      />
                    ) : (
                      <MenuButton open={sidebarOpen} item={item} />
                    )}
                  </div>
                );
              })}
            </List>
          </AccordionDetails>
        </Accordion> */}
      </Drawer>
    </>
  );
}
